<div class="reporting-layout">
  <div class="reporting-controls">
    <!-- <div class="filter-button">
          <i class="bi bi-filter"></i>
      </div> -->

    <div
      ngbDropdown
      class="d-inline-block"
      [autoClose]="'outside'"
      (openChange)="onDropdownClose($event)"
    >
      <div
        class="filter-button"
        [class.active]="hasAnyFiltersApplied()"
        ngbDropdownToggle
      >
        <i class="bi bi-filter"></i>
        Filter
      </div>

      <div ngbDropdownMenu>
        <div class="filter-dropdown-menu">
          <div class="filter-menu-header">
            <h5 class="dropdown-title">Filters</h5>

            <button
              class="btn btn-outline-primary btn-sm"
              (click)="clearFilters()"
            >
              Clear Filters
            </button>
          </div>

          <input
            inputmode="search"
            role="searchbox"
            type="search"
            name="search"
            class="form-control filter-search"
            placeholder="Search filters..."
            [(ngModel)]="filterSearch"
          />

          <div
            class="filter-category"
            *ngFor="let filter of getFilteredFilters()"
            [class.active]="
              activeSubFilter === filter.key ||
              hasSelectedFilterOption(filter.key)
            "
            (click)="setActiveSubFilter(filter.key, filterItem)"
            #filterItem
          >
            {{ filter.label }}
            <i class="bi bi-chevron-right float-end"></i>
          </div>
        </div>

        <div
          class="sub-filter-dropdown"
          *ngIf="activeSubFilter"
          [style.top.px]="subFilterTopOffset"
        >
          <h6>{{ getFilterLabel(activeSubFilter) }}</h6>

          <div
            class="option"
            *ngFor="let option of getSubFilterOptions(activeSubFilter)"
            [class.selected]="isSelectedFilterOption(activeSubFilter, option)"
            (click)="toggleFilterOption(activeSubFilter, option)"
          >
            {{ option }}
          </div>

          <div class="sub-filter-actions mt-2">
            <button class="btn btn-link" (click)="resetFilter(activeSubFilter)">
              Reset
            </button>
            <button
              class="btn btn-primary btn-sm"
              (click)="applyChartFilters()"
            >
              Apply
            </button>
          </div>
        </div>
      </div>

      <!-- Sub Filter Menu -->
    </div>

    <div>
      <label for="filterFrom" class="form-label">Filter From</label>
      <input
        type="date"
        id="filterFrom"
        class="form-control"
        [(ngModel)]="filterFromDate"
        (change)="onDateChange()"
      />
    </div>

    <div>
      <label for="filterTo" class="form-label">Filter To</label>
      <input
        type="date"
        id="filterTo"
        class="form-control"
        [(ngModel)]="filterToDate"
        (change)="onDateChange()"
      />
    </div>

    <div class="export-buttons">
      <div class="export-button" (click)="exportDataAsExcel()">
        Export to Excel
      </div>
      <!-- <div class="export-button" (click)="exportDataAsPDF()">Export PDF</div> -->
    </div>

    <!-- <input
      type="text"
      class="search-box"
      placeholder="Search..."
      [(ngModel)]="searchQuery"
      (input)="searchDonors()"
    /> -->
  </div>
  @if (loading) {
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  } @else {
    <div class="main-content">
      @if (!hasData) {
        <div class="no-data">No data to show</div>
      } @else if (!hasFilteredResults()) {
        <div class="no-data">No data matches the applied filters</div>
      } @else {
        <div id="chart-section">
          <div class="chart">
            <div class="chart-item">
              <h3 class="chart-title">Eligibility</h3>

              @if (hasFilteredResults()) {
                <p>
                  {{ "Donors: " + getChartTotal(filteredEligibilityChart) }}
                </p>
                <div #chartContainer>
                  <ngx-charts-pie-chart
                    [results]="filteredEligibilityChart"
                    (select)="onSliceClick('eligibilityStatus', $event)"
                    [legend]="false"
                    [labels]="true"
                    [doughnut]="true"
                    [explodeSlices]="false"
                    [gradient]="false"
                    [legendPosition]="chartSettings.legendPosition"
                    [arcWidth]="chartSettings.arcWidth"
                    [trimLabels]="chartSettings.trimLabels"
                    [labelFormatting]="formatEligbilityLabel"
                    [view]="responsiveChartView"
                    [scheme]="colorScheme"
                  ></ngx-charts-pie-chart>
                </div>
              } @else {
                <div class="no-data-message">No results</div>
              }
            </div>
          </div>

          <div class="chart-grid">
            <ng-container *ngFor="let entry of filteredChartEntries">
              <div class="chart">
                <div class="chart-item">
                  <h3 class="chart-title">
                    {{ this.getChartLabel(entry.key) }}
                  </h3>
                  @if (hasFilteredResults()) {
                    <!-- <p>{{ "Donors: " + getChartTotal(entry.data) }}</p> -->
                    <div #chartContainer>
                      <ngx-charts-pie-chart
                        [results]="entry.data"
                        (select)="onSliceClick(entry.key, $event)"
                        [legend]="false"
                        [labels]="true"
                        [doughnut]="true"
                        [explodeSlices]="false"
                        [gradient]="false"
                        [arcWidth]="chartSettings.arcWidth"
                        [trimLabels]="chartSettings.trimLabels"
                        [labelFormatting]="formatLabel"
                        [view]="responsiveSmallChartView"
                        [scheme]="colorScheme"
                      ></ngx-charts-pie-chart>
                    </div>
                  } @else {
                    <div class="no-data-message">No results</div>
                  }
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      }
    </div>
  }
</div>
